export default __webpack_public_path__ + "img/enter_input.acaa2988.svg";